// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { child, getDatabase, push, ref, update } from "firebase/database";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v3 } from "uuid";
import Row from "react-bootstrap/Row";
import WorkoutPicker from "components/WorkoutPicker";
import { Link, Routes, Route, useNavigate } from "react-router-dom";

export default function EditSession() {
  const [name, setName] = useState("Laden...");
  const [desc, setDesc] = useState("");
  const [amount, setAmount] = useState(5);
  const [id, setId] = useState("");
  const [repeat, setRepeat] = useState(1);
  const [restTime, setRestTime] = useState(0);
  const [time, setTime] = useState("");
  const [exercises, setExercises] = useState([]);
  const [workouts, setWorkouts] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [refHeight, setRefHeight] = useState(0);
  const [newWorkouts, setNewWorkouts] = useState([]);
  const [selWorkout, setSelWorkout] = useState();
  const [reloadModal, setReloadModal] = useState(false);
  const [type, setType] = useState(0);

  const ref = useRef(null);

  const navigate = useNavigate();

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const updateHeight = async () => {
    if (ref.current) {
      await timeout(500);
      setRefHeight(ref?.current?.offsetHeight);
    }
  };

  const addWorkout = async (isSel, item) => {
    var help = newWorkouts;
    help.push(item);
    setNewWorkouts(help);
  };

  const editWorkout = async () => {
    var help = [];

    exercises.map((obj) => {
      if (obj.template_id == selWorkout.template_id) {
        help.push(selWorkout);
      } else {
        help.push(obj);
      }
    });

    setExercises(help);

    setIsModalEdit(false);
  };

  useEffect(() => {
    if (isModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isModal]);

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setRepeat(result);
  };

  const addWorkouts = () => {
    setReloadModal(true);

    var help = exercises;

    if (!exercises) {
      help = [];
    }

    newWorkouts.map((item, index) => {
      help.push({
        template_id: item.template_id,
        reps: 10,
        rest: 120,
        sets: 3,
        time: 5,
      });
    });

    setExercises(help);

    setNewWorkouts([]);

    setReloadModal(false);

    setIsModal(false);
  };

  const handleChangeRestTime = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setRestTime(result);
  };

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  const onEditPlan = async () => {
    const refPlan = doc(db, "workouts", getParameterByName("sessionid"));

    if (name != "" && desc != "") {
      await updateDoc(refPlan, {
        name_de: name,
        desc_de: desc,
        amount: exercises.length,
        id: id,
        number: Number(repeat),
        rest: Number(restTime),
        time: time,
        exercises: exercises,
        type: type,
      });

      alert("Gespeichert.");
    } else {
      alert("Bitte alle Daten angeben.");
    }
  };

  useEffect(() => {
    function getUrlVars() {
      return getParameterByName("sessionid");
    }

    const loadPlan = async () => {
      const q = query(
        collection(db, "workouts"),
        where("__name__", "==", getUrlVars())
      );

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        setExercises(doc.data().exercises);
        setName(doc.data().name_de);
        setDesc(doc.data().desc_de);
        setAmount(doc.data().amount);
        setId(doc.data().id);
        setRepeat(doc.data().number);
        setRestTime(doc.data().rest);
        setTime(doc.data().time);
        setType(doc.data().type);

        const getData = async () => {
          const dataRef = collection(db, "exercise_templates");

          const q = query(dataRef, orderBy("muscle_group"));

          const querySnapshot = await getDocs(q);

          const elements = [];

          querySnapshot.forEach((doc) => {
            elements.push(doc.data());
          });

          setWorkouts(elements);
        };

        getData();
      });
    };

    loadPlan();
  }, []);

  const ondeletePlan = async () => {
    const refPlan = doc(db, "workouts", getParameterByName("sessionid"));

    await updateDoc(refPlan, {
      isActive: false,
    });

    window.location.replace("sessions");
  };

  function deletePlan() {
    window.confirm("Diese Übung wirklich löschen?") && ondeletePlan();
  }

  //////

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",

    borderBottom: isDragging
      ? "1px solid hsl(210, 14%, 83%)"
      : "0px solid hsl(210, 14%, 83%)",
  });

  const getListStyle = (isDraggingOver) => ({
    background: "#fff",
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      exercises,
      result.source.index,
      result.destination.index
    );

    setExercises(items);
  };

  const onRemoveWorkout = (index) => {
    setExercises([...exercises.slice(0, index), ...exercises.slice(index + 1)]);
  };

  /////

  const selPage = "sessions";

  const ModelItems = () => (
    <>
      {workouts &&
        workouts?.map((item, index) => (
          <>
            <WorkoutPicker item={item} index={index} addWorkout={addWorkout} />
          </>
        ))}
    </>
  );

  const Content = () => (
    <section className="home-section">
      <div className="text">Trainingseinheit bearbeiten</div>

      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className="plan-data"
        id="plan-data"
      >
        <div className="container">
          <h2 id="plan-title">{name}</h2>

          <form className="contact-form">
            <p>Name:</p>
            <input
              type="search"
              className="plan-name"
              placeholder="Name"
              id="plan-name"
              value={name}
              onChange={(evt) => {
                setName(evt.target.value);
              }}
            />
            <p>Beschreibung</p>
            <textarea
              style={{ resize: "vertical", maxHeight: "none" }}
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
            ></textarea>
            <p>Wiederholungen:</p>
            <input
              type="number"
              key="repeatkey"
              min="1"
              max="99"
              value={repeat}
              onChange={handleChange}
              className="plan-weeks"
            />
            <p>{"Pause zwischen Wiederholungen (Sekunden):"}</p>
            <input
              type="number"
              key="restkey"
              min="1"
              max="999"
              value={restTime}
              onChange={handleChangeRestTime}
              className="plan-weeks"
            />
            <p>{"Dauer des Trainings (Minuten):"}</p>
            <input
              type="search"
              className="plan-name"
              placeholder="Dauer"
              value={time}
              onChange={(evt) => {
                setTime(evt.target.value);
              }}
            />

            <p>Übungstyp</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={type}
              onChange={(evt) => {
                setType(Number(evt.target.value));
              }}
            >
              <option value="0">Laufen</option>
              <option value="1">Intervall</option>
              <option value="2">Fordender Lauf</option>
              <option value="3">Kraft</option>
              <option value="4">Gemischt</option>
              <option value="5">Ausdauer</option>
            </select>

            <p>{"Übungen:"}</p>

            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {exercises &&
                      exercises.map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={index + ""}
                          index={index}
                        >
                          {(provided, snapshot2) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={index}
                              className="list-container"
                            >
                              <div
                                style={getItemStyle(
                                  snapshot2.isDragging,
                                  provided.draggableProps.style
                                )}
                                className="list-item"
                              >
                                <i className="fa-solid fa-bars">
                                  <FontAwesomeIcon
                                    icon={icon({
                                      name: "bars",
                                      style: "solid",
                                    })}
                                  />
                                </i>
                                <a>
                                  <p>
                                    {
                                      workouts.filter(
                                        (obj) =>
                                          obj.template_id == item.template_id
                                      )[0]?.name_de
                                    }
                                  </p>
                                  <p style={{ fontSize: 10, paddingTop: 3 }}>
                                    {"Wdh: " +
                                      (item.reps == "" ? "-" : item.reps) +
                                      ", Sätze: " +
                                      (item.sets == "" ? "-" : item.sets) +
                                      ", Pause: " +
                                      (item.rest == ""
                                        ? "-"
                                        : item.rest + " Sek") +
                                      ", Dauer: " +
                                      (item.time == ""
                                        ? "-"
                                        : item.time + " Min")}
                                  </p>
                                </a>

                                <i
                                  style={{ marginLeft: "auto" }}
                                  className="fa-solid fa-pen"
                                >
                                  <a
                                    onClick={() => {
                                      setIsModalEdit(true);
                                      setSelWorkout(item);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <FontAwesomeIcon
                                      style={{ color: "#21252b" }}
                                      icon={icon({
                                        name: "pencil",
                                        style: "solid",
                                      })}
                                    />
                                  </a>
                                  <a
                                    style={{
                                      paddingLeft: 25,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      onRemoveWorkout(index);
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      style={{
                                        color: "red",
                                      }}
                                      icon={icon({
                                        name: "trash-can",
                                        style: "regular",
                                      })}
                                    />
                                  </a>
                                </i>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            <a
              onClick={() => {
                setIsModal(true);
                updateHeight();
              }}
              style={{ borderTop: "1px solid hsl(210, 14%, 83%)" }}
              className="list-container"
            >
              <div className="list-item add-workout">
                <i style={{ color: "#7a3260" }} className="fa-solid fa-bars">
                  <FontAwesomeIcon
                    icon={icon({ name: "plus", style: "solid" })}
                  />
                </i>
                <p>{"Übungen hinzufügen"}</p>
              </div>
            </a>
          </form>

          <div className="form-button">
            <div style={{ display: "flex" }}>
              <button
                onClick={() => onEditPlan()}
                className="btn submit-form"
                type="submit"
              >
                Speichern
              </button>
              <div style={{ width: 10 }}></div>

              <button
                onClick={() => navigate(-1)}
                className="btn btn-gray submit-form"
                type="submit"
              >
                Abbrechen
              </button>
              <div style={{ width: 10 }}></div>
            </div>
            <button
              onClick={() => deletePlan()}
              className="btn btn-red submit-form"
              type="submit"
            >
              Löschen
            </button>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {/* Add Workout Modal */}

      <div
        style={{
          zIndex: 999,
          display: isModal ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg "}
      >
        <ul
          ref={ref}
          className={"mobile-nav " + (isModal ? "slide-in" : "slide-out")}
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <li>
            <a>Wähle Übungen zum hinzufügen aus:</a>
          </li>

          <ModelItems></ModelItems>

          <button
            onClick={() => {
              addWorkouts();
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 0, marginRight: 10 }}
          >
            Übungen hinzufügen
          </button>

          <button
            onClick={() => {
              setIsModal(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModal(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
            height: refHeight,
          }}
        ></div>
      </div>

      {/* Edit Workout Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalEdit ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          className={"mobile-nav " + (isModalEdit ? "slide-in" : "slide-out")}
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {
                workouts.filter(
                  (obj) => obj.template_id == selWorkout?.template_id
                )[0]?.name_de
              }
            </p>

            <p style={{ color: "#fff", paddingBottom: 16 }}>
              {"Dauer (Minuten):"}
            </p>
            <input
              type="number"
              key="restkey"
              min="1"
              max="999"
              value={selWorkout ? selWorkout?.time : ""}
              onChange={(evt) => {
                var help = [{ ...selWorkout, time: Number(evt.target.value) }];

                setSelWorkout(null);

                setSelWorkout(help[0]);
              }}
              className="plan-weeks"
            />

            <p style={{ color: "#fff", paddingBottom: 16 }}>
              {"Pause zwischen Sätzen (Sekunden):"}
            </p>

            <input
              type="number"
              key="restkey"
              min="1"
              max="999"
              value={selWorkout ? selWorkout?.rest : ""}
              onChange={(evt) => {
                setSelWorkout(null);

                var help = [{ ...selWorkout, rest: Number(evt.target.value) }];

                setSelWorkout(help[0]);
              }}
              className="plan-weeks"
            />

            <p style={{ color: "#fff", paddingBottom: 16 }}>{"Sätze:"}</p>

            <input
              type="number"
              key="restkey"
              min="1"
              max="999"
              value={selWorkout ? selWorkout?.sets : ""}
              onChange={(evt) => {
                setSelWorkout(null);

                var help = [{ ...selWorkout, sets: Number(evt.target.value) }];

                setSelWorkout(help[0]);
              }}
              className="plan-weeks"
            />

            <p style={{ color: "#fff", paddingBottom: 16 }}>
              {"Wiederholungen:"}
            </p>

            <input
              type="number"
              key="restkey"
              min="1"
              max="999"
              value={selWorkout ? selWorkout?.reps : ""}
              onChange={(evt) => {
                setSelWorkout(null);

                var help = [{ ...selWorkout, reps: Number(evt.target.value) }];

                setSelWorkout(help[0]);
              }}
              className="plan-weeks"
            />

            <p></p>
          </form>

          <button
            onClick={() => {
              editWorkout();
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 0, marginRight: 10 }}
          >
            Speichern
          </button>

          <button
            onClick={() => {
              setIsModalEdit(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalEdit(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2, //"50%",
            width: windowDimensions.width - 600, //"50%",
            minHeight: "100%",
          }}
        ></div>
      </div>
      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
